import Storage from "@aws-amplify/storage";
import config from "../config";
import axios from "axios";

export async function fileData (fileName)  {
  try {
  const libFile = await Storage.get(fileName, {bucket: config.s3.BUCKET, level: "private" } );
  let temp = await axios({
        method:"GET",
        url: libFile.toString(),
        headers: {
           "Access-Control-Allow-Credentials" : true,
           "Access-Control-Allow-Origin":"*",
           "Access-Control-Allow-Methods":"GET",
           "Content-Type": "application/json"
         }
       })
    return temp.data;
    } catch (e){
      console.log(e)
      return null
    }
  };

  export async function getLocations () {
    return await fileData("savedLocation.json");
  }

  export async function getOPDS () {
    return await fileData("epub_library.opds");
  }

  export async function checkSavedLocations () {
    try {
      let current = await fileData("savedLocation.json");
      if (current === null) {
        let json = [];
        await Storage.put("savedLocation.json", JSON.stringify (json), {
          bucket: config.s3.BUCKET, level: "private"
        });
      return "File made"
      }

      return "File already exists"
    } catch (e ) {
      return e.toString()
    }
  }
export const languages =
  [
    {key: "fr", text:"French", value: "fr"},
    {key: "en", text:"English",  value: "en"},
  ];
  export const languagesFR =
  [
    {key: 'fr', text:'Français', value: 'fr'},
    {key: 'en', text:'Anglais',  value: 'en'},
  ];

  export function getLang()
  {
    let language;
    let languageArr;
    if (typeof window !== `undefined`) {
     if (navigator && navigator.languages !== undefined)
     {
       languageArr = navigator.languages[0].split("-");

     }
     else if (navigator) {
       return navigator.language;
     }
     if (languageArr) {
       language = languageArr[0];

       return language;
     }
      return language;
   }
   return "en"

  }
